export const isValidUrl = url => {
  let urlBuilt;
  try {
    urlBuilt = new URL(url);
  } catch {
    return false;
  }
  return Boolean(urlBuilt);
};
